
export default Object.freeze({
  NORMAL: Symbol('normal'),
  GHOST: Symbol('ghost'),
  TRANSPARENT: Symbol('transparent')
});



// WEBPACK FOOTER //
// ./src/assets/javascripts/MaterialTypes.js